<script lang="ts">
	interface Option {
		id: string
		value: string
		label: string
		required?: boolean
	}

	interface Props {
		name?: string
		label?: string
		options: Array<Option>
		instruction?: string
		value?: Array<string>
		at_least_one?: boolean
	}

	let {
		name,
		label = undefined,
		options,
		instruction = undefined,
		value: group = $bindable([]),
		at_least_one = undefined
	}: Props = $props()

	const has_required = $derived(at_least_one || options?.some(option => option.required))
</script>

<div class="checkboxes">
	{#if label}
		<div class="label" data-required={has_required}>{label}</div>
	{/if}
	<fieldset class="items">
		{#each options as { id, value, label: option_label, required: option_required }, index (index)}
			<div>
				<input class="input" type="checkbox" {id} {name} {value} required={option_required} bind:group />
				<label class="checkbox" for={id}>
					<span data-required={!label && has_required}>{option_label}</span>
				</label>
			</div>
		{/each}
	</fieldset>
	{#if instruction}
		<div class="instruction">{instruction}</div>
	{/if}
</div>

<style lang="css">
	.label {
		color: var(--c-foreground, var(--c-crocus));
		display: block;
		font: 500 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-end: 0.5rem;
	}

	.input {
		inset: 0 auto auto 0;
		opacity: 0;
		position: absolute;
		size: 1.375rem;

		&:checked + .checkbox::before {
			background-color: var(--c-foreground, var(--c-crocus));
			background-position: center center;
		}
	}

	.checkbox {
		align-items: center;
		display: flex;
		cursor: pointer;
		font: 400 var(--f-body2);
		gap: 0.5rem;
		letter-spacing: var(--ls-body2);

		&::before {
			background-image: url("data:image/svg+xml;charset=utf8,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 12.5L10 16L18 8' stroke='white' stroke-width='1.5' stroke-linejoin='round'/%3E%3C/svg%3E");
			background-position: center 1.5rem;
			background-size: 1.375rem;
			border: 1.5px solid var(--c-foreground, var(--c-crocus));
			border-radius: var(--r-xxs);
			content: '';
			display: block;
			flex-shrink: 0;
			transition: background-position 0.2s ease;
			size: 1.375rem;
		}
	}

	.items {
		display: grid;
		gap: 1rem;
		margin: 0;
	}

	.instruction {
		margin-block-start: 0.625rem;
	}
</style>
